<template>  
  <!-- Modal -->
  <div class="modal fade adult_modal" id="adultModal" tabindex="-1" role="dialog" aria-labelledby="adultModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header adult_modal--caption pt-5">
          <h3 class="modal-title">年齢確認</h3>
        </div>
        <div class="modal-body">
          <h5 class="adult_modal--title pb-1">
            あなたは18歳以上ですか？
          </h5>
          <p class="adult_modal--content">
            ここから先は、アダルト商品の詳細ページです。<br />
            18歳未満の方のアクセスは固くお断りします。
          </p>
        </div>
        <div class="modal-footer adult_modal--footer pb-4 pt-0">
          <button type="button" class="btn px-5 btn-secondary" @click="notAgree">いいえ</button>
          <button type="button" class="btn px-5 btn-primary" @click="agree">はい</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['isAdult'],
    data() {
      return {
      }
    },
    mounted () {
      var isAdult = localStorage.getItem('isAdult')
      if (this.isAdult && isAdult != 'true') {
        $('#adultModal').modal({
          backdrop: false,
          show: true,
        })
      }
    },
    methods: {
      notAgree() {
        localStorage.setItem('isAdult', false)
        this.$swal(
          '', '18歳未満の方はアクセスできません。','warning'
        ).then(() => {
          window.location.href="/"
        })
      },
      agree: () => {
        $('#adultModal').modal('hide')
        localStorage.setItem('isAdult', true)
      }
    },
    created() {
    },
    destroyed() {
    },
  }
</script>
<style lang="scss">
  .adult_modal {
    background: rgba($color: white, $alpha: 0.8);
    backdrop-filter:blur(6px);
    &--caption {
      justify-content: center;
      border-bottom: none;
      font-size: 32px;
    }
    &--title {
      text-align: center;
      font-size: 20px;
      font-weight: bold;
    }
    &--content {
      text-align: center;
      font-size: 16px;
      color: #454545;
    }
    &--footer {
      justify-content: center;
      border-top: none;
    }
  }
</style>